









import { Vue, Component, Prop } from 'vue-property-decorator'
import { Empty } from 'vant'
import { isHzwApp, isMmz } from '@utils/cookie'
import router from '@/app/app-routing'

const ImgEmpty = require('@assets/images/search/icon_empty.png')


@Component({
  components: {
    [Empty.name]: Empty
  }
})
export default class EmptyComponent extends Vue {
  @Prop({ default: '早教' }) readonly keyword!: string
  @Prop({ default: true }) readonly emptyShowbtn!: boolean  //是否显示重置筛选
  @Prop() readonly errormsg!: string
  @Prop({ default: 500 }) readonly height!: number
  @Prop({ default: () => ImgEmpty }) readonly defalutImg!: any
  @Prop({ default: false }) readonly innerComponent!: boolean  //是否是搜索内部的组件 如商家 商品列表组件

  get noDataMessage() {
    if(this.errormsg) return this.errormsg
    if(this.innerComponent) {
       if(!this.emptyShowbtn){
         return '没有找到相关的内容哦～'
       }
       return '没有找到筛选内容呢～'
    }
    if(!this.keyword) return '没有找到相关的内容哦～'
    if (isHzwApp()) {
      return `没有找到与“${this.keyword}”相关的内容哦，告诉我们你想要的，我们马上寻找相关优质服务`
    } else {
      return `没有找到与“${this.keyword}”相关的内容哦～`
    }
  }

  get mmz(){
    return isMmz()
  }

  get ImageSrc(){
     if(this.errormsg){
       return  require('@assets/images/search/icon_error.png')
     }
     return this.defalutImg
  }

  click(){
      if(this.errormsg){
        this.$emit('reload')
      }else if(this.innerComponent){
         this.$emit('reset')
      }else{
         if(isHzwApp()){
           location.href = `https://w.cekid.com/feedback/suggest-form.html?type=search&cmd=share&sharetype=0&key=${this.keyword}`
         }else{
           //跳转到城市站首页
            router.push({ name: 'home' })
         }
      }
  }

  get btnMessage() {
    if(this.errormsg) return '重新加载'
    if(this.innerComponent) return '重置筛选项'
    if (isHzwApp()) {
      return '立即反馈'
    } else {
      return '随便看看'
    }
  }

  
}
